import React, { Component } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField, 
  Grid, 
  Typography,
  CardHeader,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { es } from 'date-fns/locale';
import moment from 'moment';

class ConsultoriaDisponibilidad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fecha: new Date(),
      horaInicio: moment().hour(8).minute(0).toDate(),
      horaFin: moment().hour(17).minute(0).toDate(),
    };
  }

  handleFechaChange = (fecha) => {
    this.setState({ fecha });
  }

  handleHoraInicioChange = (horaInicio) => {
    this.setState({ horaInicio });
  }

  handleHoraFinChange = (horaFin) => {
    this.setState({ horaFin });
  }

  

  guardarDisponibilidad = () => {
    const { fecha, horaInicio, horaFin } = this.state;
    
    const disponibilidad = {
      fecha: moment(fecha).format('YYYY-MM-DD'),
      horaInicio: moment(horaInicio).format('HH:mm'),
      horaFin: moment(horaFin).format('HH:mm')
    };
    
    this.props.guardarDisponibilidad(disponibilidad);
    this.props.mostrarModalDisponibilidad(false);
  }

  render() {
    const { modalDisponibilidad, mostrarModalDisponibilidad } = this.props;
    const { fecha, horaInicio, horaFin } = this.state;
    
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
        <Dialog
          open={modalDisponibilidad}
          onClose={() => mostrarModalDisponibilidad(false)}
          aria-labelledby="form-dialog-title"
          maxWidth="md"
          fullWidth
        >
          <CardHeader
            avatar={<Avatar aria-label="disponibilidad" style={{ backgroundColor: "#B70E0C" }}>D</Avatar>}
            title="Configurar Disponibilidad"
          />
          <DialogContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" color="textSecondary">
                  Configure su disponibilidad para consultoría
                </Typography>
              </Grid>

                <Grid item xs={12}>
                  <KeyboardDatePicker
                    fullWidth
                    label="Fecha disponible"
                    format="dd/MM/yyyy"
                    value={fecha}
                    onChange={this.handleFechaChange}
                    minDate={new Date()}
                    KeyboardButtonProps={{
                      'aria-label': 'cambiar fecha',
                    }}
                    invalidDateMessage="Formato de fecha inválido"
                    minDateMessage="La fecha debe ser mayor o igual a hoy"
                  />
                </Grid>
              
              
              {/* Horarios */}
              <Grid item xs={6}>
                <KeyboardTimePicker
                  fullWidth
                  label="Hora de inicio"
                  value={horaInicio}
                  onChange={this.handleHoraInicioChange}
                  KeyboardButtonProps={{
                    'aria-label': 'cambiar hora inicio',
                  }}
                  ampm={false}
                  minutesStep={15}
                />
              </Grid>
              <Grid item xs={6}>
                <KeyboardTimePicker
                  fullWidth
                  label="Hora de fin"
                  value={horaFin}
                  onChange={this.handleHoraFinChange}
                  KeyboardButtonProps={{
                    'aria-label': 'cambiar hora fin',
                  }}
                  ampm={false}
                  minutesStep={15}
                  minTime={horaInicio}
                />
              </Grid>

              {/* Información adicional */}
              <Grid item xs={12}>
                <Box 
                  sx={{ 
                    backgroundColor: '#f5f5f5', 
                    padding: 2, 
                    borderRadius: 1,
                    marginTop: 1
                  }}
                >
                  <Typography variant="body2" color="textSecondary">
                    <strong>Información:</strong>
                    <br />
                    • La disponibilidad se aplica a todas las solicitudes de consultoría
                    <br />
                    • La duración mínima de una consultoría es de 30 minutos
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => mostrarModalDisponibilidad(false)} color="primary">
              Cancelar
            </Button>
            <Button 
              onClick={this.guardarDisponibilidad} 
              color="primary" 
              variant="contained"
              style={{ backgroundColor: "#B70E0C" }}
            >
              Guardar Disponibilidad
            </Button>
          </DialogActions>
        </Dialog>
      </MuiPickersUtilsProvider>
    );
  }
}

export default ConsultoriaDisponibilidad;